/**
 * 网络参数
 * author:brian author 2022 05 20
 */
import * as validator from '@/utils/validate.js';
import { channelMask, checkNumber, EnNumber } from '../ownRules.js';

import { RuleExtPanId, RuleChannelMask, RuleChannelPage } from '@/utils/rules.js';
export function NetRules() {
    return {
        extPanId: RuleExtPanId,
        channelPage: RuleChannelPage,
        channelMask: RuleChannelMask,
        transmitPower: [
            { required: true, message: $t('integration.transmit_power_cannot_be_empty'), trigger: 'blur' },
            {
                validator: validator.FormValidate.maxMinFn('channelPage').netRule,
                trigger: 'blur'
            }
        ],
        inNetInterval: [
            { required: true, message: $t('integration.the_network_access_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        // lora
        devEui: [
            { required: true, message: $t('integration.deveui_cannot_be_empty'), trigger: 'blur' },
            {
                validator: EnNumber,
                trigger: 'blur'
            }
        ],
        appEui: [
            { required: true, message: $t('integration.appeui_cannot_be_empty'), trigger: 'blur' },
            {
                validator: EnNumber,
                trigger: 'blur'
            }
        ],
        appKey: [
            { required: true, message: $t('integration.appkey_cannot_be_empty'), trigger: 'blur' },
            {
                validator: EnNumber,
                trigger: 'blur'
            }
        ],
        // 上报规则
        collectInterval: [
            { required: true, message: $t('integration.collection_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        exCollectInterval: [
            { required: true, message: $t('integration.exception_collection_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        tempCollectInterval: [
            { required: true, message: $t('integration.the_temperature_collection_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],

        tempChange: [
            { required: true, message: $t('integration.temperature_change_threshold_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        tempMaxReport: [
            { required: true, message: $t('integration.the_maximum_temperature_reporting_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        tempMinReport: [
            { required: true, message: $t('integration.the_minimum_reporting_interval_of_temperature_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        humCollectInterval: [
            { required: true, message: $t('integration.humidity_collection_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        humChange: [
            { required: true, message: $t('integration.humidity_change_threshold_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        humMaxReport: [
            { required: true, message: $t('integration.the_maximum_humidity_reporting_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        humMinReport: [
            { required: true, message: $t('integration.the_minimum_humidity_reporting_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ]
    };
}
